
import _ from 'lodash';
import StatusColumn from './status-column.vue';
import TableList from '@/components/TableList/index.vue';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { interactiveChannelList } from '@com/utils/channel';
import { allNonInteractiveChannelList } from '@/views/demand/utils/creation';
import { customerTypeList, exchangeCreationTypes } from '@/common/demand';

export default {
  components: {
    TableList: TableList
  },

  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    columnConfig: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    handleSelectionChange: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      tableConfig: {
        'row-class-name': function rowClassName(_ref) {
          var row = _ref.row,
              rowIndex = _ref.rowIndex;

          if (row.status === 'submited' || row.status === 'confirmed') {
            return '';
          }
          return 'hide-checkbox';
        }
      },
      tableColumnConfig: [{
        label: '选择',
        prop: 'selection',
        type: 'selection'
      }, {
        label: 'ID',
        prop: 'id',
        width: 70,
        sortable: 'custom'
      }, {
        prop: 'creation-cell',
        slot: 'creation-cell'
      }, {
        prop: 'cancle-cell',
        slot: 'cancle-cell'
      }, {
        prop: 'estimated-cell',
        slot: 'estimated-cell'
      }, {
        label: '需求名称',
        prop: 'name',
        type: 'link',
        params: {
          tips: function tips(_ref2) {
            var row = _ref2.row;

            return row.instruction;
          },
          link: function link(_ref3) {
            var row = _ref3.row;

            return '/butler/demand-detail/' + row.id;
          }
        }
      }, {
        label: '产品名称',
        prop: 'app_names'
      }, {
        label: '需求说明',
        prop: 'instruction',
        params: {
          maxLength: 25
        }
      }, {
        label: '创意标签',
        prop: 'tag_names',
        params: {
          maxLength: 25
        }
      }, {
        label: 'Size',
        prop: 'attachment_size',
        type: 'filesize'
      }, {
        label: '需求评级',
        prop: 'difficulty'
      }, {
        label: '关联需求',
        prop: 'demand_name',
        type: 'link',
        params: {
          link: function link(_ref4) {
            var row = _ref4.row;

            return '/butler/demand-detail/' + row.demand_id;
          }
        }
      }, {
        label: '创意类型',
        prop: 'creation_types',
        params: {
          innerText: function innerText(_ref5) {
            var row = _ref5.row;

            return exchangeCreationTypes(row.creation_types) || '-';
          }
        }
      }, {
        label: '投放平台',
        prop: 'platforms'
      }, {
        label: '投放渠道/语言',
        prop: 'channels',
        params: {
          innerHTML: function innerHTML(_ref6) {
            var row = _ref6.row;

            if (row && row.creation_tasks && row.creation_tasks.length) {
              return row.creation_tasks.map(function (task) {
                var channels = task.channel_ids.split(',');
                return channels.map(function (channel) {
                  // 因为交互素材中头条得显示巨量引擎，所以，如果是交互类型，则从 ineractiveChannelList 中拿 label 值
                  return useValueExchangeLabel(Number(channel), row.type === 1 ? interactiveChannelList : allNonInteractiveChannelList());
                }).join() + ': ' + task.languages;
              }).reduce(function (accumulator, currentValue) {
                return accumulator + '<div>' + currentValue + '</div>';
              }, '');
            }
            return '-';
          }
        }
      },
      // 创意报表使用
      {
        label: '投放渠道/语言',
        prop: 'channel',
        params: {
          innerText: function innerText(_ref7) {
            var row = _ref7.row;

            if (row && row.channel) {
              return row.channel + ': ' + row.languages;
            }
            return '-';
          }
        }
      }, {
        label: '是否KA',
        prop: 'key_account',
        params: {
          innerText: function innerText(_ref8) {
            var row = _ref8.row;

            return useValueExchangeLabel(row.key_account, customerTypeList);
          }
        }
      }, {
        label: '我的优先级',
        prop: 'priority'
      }, {
        label: '状态',
        prop: 'status',
        component: StatusColumn
      }, {
        label: '提需人',
        prop: 'demander_name'
      }, {
        label: '设计师',
        prop: 'designer_name'
      }, {
        label: '广告主',
        prop: 'adv_name'
      }, {
        label: '提需日期',
        prop: 'submit_time'
      }, {
        label: '期望完成日期',
        prop: 'expect_time'
      }, {
        label: '计划完成日期',
        prop: 'estimated_time'
      }, {
        label: '工时消耗',
        prop: 'worktime'
      }, {
        label: '实际完成日期',
        prop: 'deliver_time'
      }, {
        label: '开始时间',
        prop: 'start_date'
      }, {
        label: '结束时间',
        prop: 'end_date'
      }, {
        label: '计划完成日期（新）',
        prop: 'newday'
      }, {
        label: '创意名称',
        prop: 'creation_name'
      }, {
        label: '创意标签',
        prop: 'tag_ids'
      }, {
        label: '创意标签',
        prop: 'tags',
        params: {
          maxLength: 25
        }
      }, {
        label: 'Dimension',
        prop: 'creation_size'
      }, {
        label: 'impression',
        prop: 'impression'
      }, {
        label: 'click',
        prop: 'clicks'
      }, {
        label: 'install',
        prop: 'install'
      }, {
        label: 'Spend',
        prop: 'spend'
      }, {
        label: 'CPI',
        prop: 'cpi'
      }, {
        label: 'CTR',
        prop: 'ctr'
      }, {
        label: 'CVR',
        prop: 'cvr'
      }, {
        label: 'IVR',
        prop: 'ivr'
      }, {
        label: 'ROI',
        prop: 'roi'
      }, {
        label: 'eCPC',
        prop: 'ecpc'
      }, {
        label: 'eCPM',
        prop: 'ecpm'
      }, {
        label: '研发',
        prop: 'developer_name'
      }, {
        label: '关联测试任务',
        prop: 'total_tasks',
        params: {
          innerHTML: function innerHTML(_ref9) {
            var row = _ref9.row;

            if (row && row.total_tasks) {
              return '<a href="#/manage/qa?demand_id=' + row.id + '&demand_name=' + row.name + '">' + row.done_tasks + '</a> / ' + row.total_tasks;
            }
            return row.total_tasks;
          }
        }
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }, {
        label: '需求类型',
        prop: 'type'
      }]
    };
  },


  computed: {
    innerList: function innerList() {
      if (_.isArray(this.list)) {
        return this.list.map(function (item) {
          if (item.work_days) {
            item.worktime = item.work_days + 'd';
          }
          if (item.work_hours) {
            item.worktime = item.work_hours + 'h';
          }
          return item;
        });
      }
      return [];
    },


    // 过滤表数据
    filterColumnConfig: function filterColumnConfig() {
      var _this = this;

      var tempConfig = [];
      this.columnConfig.map(function (columnProp) {
        _this.tableColumnConfig.map(function (item) {
          if (columnProp && item.prop === columnProp) {
            tempConfig.push(item);
          }
        });
      });

      return tempConfig;
    }
  },

  methods: {}
};